import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { InputDialogComponent } from './input-dialog/input-dialog.component';
import { LocalizationComponent } from './localization/localization.component';

import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QRCodeModule } from 'angularx-qrcode';
import { LocalizedInputComponent } from '../admin/localized-input/localized-input.component';
import { ArComponent } from '../configurator/product/ar/ar.component';
import { AttributeValueComponent } from '../configurator/product/product-configuration/attribute-value/attribute-value.component';
import { AttributeComponent } from '../configurator/product/product-configuration/attribute/attribute.component';
import { CategorisedProductBlueprintSelectComponent } from '../configurator/product/product-configuration/categorised-product-blueprint-select/categorised-product-blueprint-select.component';
import { ContextMenuComponent } from '../configurator/product/product-configuration/context-menu/context-menu.component';
import { DetailsComponent } from '../configurator/product/product-configuration/details/details.component';
import { GlobalAttributesSelectComponent } from '../configurator/product/product-configuration/global-attributes-select/global-attributes-select.component';
import { MeasurementLineContextMenuComponent } from '../configurator/product/product-configuration/measurement-line-context-menu/measurement-line-context-menu.component';
import { NumericAttributeSelectComponent } from '../configurator/product/product-configuration/numeric-attribute-select-component/numeric-attribute-select.component';
import { NumericAttributeComponent } from '../configurator/product/product-configuration/numeric-attribute/numeric-attribute.component';
import { ProductBlueprintSelectComponent } from '../configurator/product/product-configuration/product-blueprint-select/product-blueprint-select.component';
import { ProductRelationshipSelectComponent } from '../configurator/product/product-configuration/product-relationship-select/product-relationship-select.component';
import { ExtraProductBlueprintConfigurationComponent } from '../configurator/submit/extra-product-blueprint-configuration/extra-product-blueprint-configuration.component';
import { AppDateAdapter } from '../utils/AppDateAdapter';
import { getSlovenePaginatorIntl } from '../utils/SlovenskiPaginator';
import { AttributeSettingsDisplayComponent } from './attribute-settings-display/attribute-settings-display.component';
import { CartDisplayComponent } from './cart-display/cart-display.component';
import { UnitConversionDirective } from './directives/unit-conversion.directive';
import { LocalizationService } from './localization/localization.service';
import { FindPBPByIdPipe } from './pipes/find-pbpby-id.pipe';
import { UnitConversionPipe } from './pipes/unit-conversion.pipe';
import { PoweredByComponent } from './powered-by/powered-by.component';
import { PreviewSideSelectComponent } from './preview-side-select/preview-side-select.component';
import { ProductTwoDConfigurationComponent } from './product-two-dconfiguration/product-two-dconfiguration.component';
import { TargetedProductBlueprintAttributeEditingComponent } from './targeted-product-blueprint-attribute-editing/targeted-product-blueprint-attribute-editing.component';
import { TwoDAttributeValueSelectComponent } from './two-dattribute-value-select/two-dattribute-value-select.component';
import { TwoDnumericAttributeValueSelectComponent } from './two-dnumeric-attribute-value-select/two-dnumeric-attribute-value-select.component';
import { MatSliderModule } from '@angular/material/slider';

export const DateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@NgModule({
  declarations: [
    LocalizationComponent,
    InputDialogComponent,
    ConfirmDialogComponent,
    UnitConversionDirective,
    CartDisplayComponent,
    FindPBPByIdPipe,
    AttributeSettingsDisplayComponent,
    LocalizedInputComponent,
    PreviewSideSelectComponent,
    PoweredByComponent,
    UnitConversionPipe,
    ProductTwoDConfigurationComponent,
    TwoDAttributeValueSelectComponent,
    ContextMenuComponent,
    MeasurementLineContextMenuComponent,
    ProductBlueprintSelectComponent,
    ProductRelationshipSelectComponent,
    GlobalAttributesSelectComponent,
    CategorisedProductBlueprintSelectComponent,
    AttributeComponent,
    NumericAttributeComponent,
    NumericAttributeSelectComponent,
    AttributeValueComponent,
    DetailsComponent,
    ExtraProductBlueprintConfigurationComponent,
    ArComponent,
    TargetedProductBlueprintAttributeEditingComponent,

    TwoDnumericAttributeValueSelectComponent,
  ],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    MatRippleModule,
    MatStepperModule,
    MatTableModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    QRCodeModule,
    MatExpansionModule,
    MatSliderModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  exports: [
    LocalizationComponent,
    InputDialogComponent,
    ConfirmDialogComponent,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatTabsModule,
    MatCheckboxModule,
    MatRippleModule,
    MatDividerModule,
    MatChipsModule,
    MatSnackBarModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatStepperModule,
    UnitConversionDirective,
    CartDisplayComponent,
    LocalizedInputComponent,
    PreviewSideSelectComponent,
    PoweredByComponent,
    UnitConversionPipe,
    MatTooltipModule,
    ProductTwoDConfigurationComponent,
    ContextMenuComponent,
    MeasurementLineContextMenuComponent,
    ProductBlueprintSelectComponent,
    ProductRelationshipSelectComponent,
    GlobalAttributesSelectComponent,
    CategorisedProductBlueprintSelectComponent,
    AttributeComponent,
    NumericAttributeComponent,
    NumericAttributeSelectComponent,
    AttributeValueComponent,
    DetailsComponent,
    ExtraProductBlueprintConfigurationComponent,
    ArComponent,
    TargetedProductBlueprintAttributeEditingComponent,
    MatSliderModule,
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: DateFormats },
    { provide: DateAdapter, useClass: AppDateAdapter },
    {
      provide: MatPaginatorIntl,
      useFactory: (localizationService: LocalizationService) => getSlovenePaginatorIntl(localizationService),
      deps: [LocalizationService],
    },
  ],
})
export class SharedModule {}
